const typeRepeat = [
    { name: 'Hàng ngày', code: 1 },
    { name: 'Hàng tuần', code: 2 },
    { name: 'Hàng tháng ', code: 3 },
];
export default typeRepeat;
